/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateClockInPortalData
 */
export interface UpdateClockInPortalData {
    /**
     * 
     * @type {string}
     * @memberof UpdateClockInPortalData
     */
    name?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateClockInPortalData
     */
    locations?: Array<number>;
}

/**
 * Check if a given object implements the UpdateClockInPortalData interface.
 */
export function instanceOfUpdateClockInPortalData(value: object): value is UpdateClockInPortalData {
    return true;
}

export function UpdateClockInPortalDataFromJSON(json: any): UpdateClockInPortalData {
    return UpdateClockInPortalDataFromJSONTyped(json, false);
}

export function UpdateClockInPortalDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClockInPortalData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'locations': json['locations'] == null ? undefined : json['locations'],
    };
}

  export function UpdateClockInPortalDataToJSON(json: any): UpdateClockInPortalData {
      return UpdateClockInPortalDataToJSONTyped(json, false);
  }

  export function UpdateClockInPortalDataToJSONTyped(value?: UpdateClockInPortalData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'locations': value['locations'],
    };
}

